export const ApiUrlsUrls = {
  choices: '/urls/api-schema',
  update: '/urls/:id',
};
